// Derived from the generated schema (--enum-values), so new WebhookEventType values flow through on regen.
import { createWebhookSubscriptionRequestEventTypesValues } from "@dolfin/api-admin";

export type WebhookEventWire =
  (typeof createWebhookSubscriptionRequestEventTypesValues)[number];

export const ALL_WEBHOOK_EVENTS: readonly WebhookEventWire[] =
  createWebhookSubscriptionRequestEventTypesValues;

// Grouped by wire-name prefix; an unlisted prefix lands under "Other", so no event is ever hidden.
const GROUP_BY_PREFIX: { prefix: string; group: string }[] = [
  { prefix: "bill.", group: "Bills" },
  { prefix: "invoice.", group: "Invoices" },
  { prefix: "recurring_invoice.", group: "Recurring invoices" },
  { prefix: "credit_note.", group: "Credit notes" },
  // More specific prefix first, so ordering doesn't rely on the dot.
  { prefix: "supplier_credit", group: "Supplier credits" },
  { prefix: "match_group.", group: "Matching" },
  { prefix: "customer.", group: "Customers" },
  { prefix: "supplier.", group: "Suppliers" },
  { prefix: "product.", group: "Products" },
  { prefix: "tax_rate.", group: "Tax rates" },
  { prefix: "approval_policy.", group: "Approval policies" },
  { prefix: "expense.", group: "Expenses" },
  { prefix: "card_", group: "Cards" },
  { prefix: "company_bill.", group: "Company inbox" },
  // Same rule: more specific first ("e_invoice" is a prefix of "e_invoicing").
  { prefix: "e_invoicing_registration.", group: "E-invoicing registration" },
  { prefix: "e_invoice.", group: "E-invoices" },
];

function groupFor(event: WebhookEventWire): string {
  return GROUP_BY_PREFIX.find((g) => event.startsWith(g.prefix))?.group ?? "Other";
}

export const WEBHOOK_EVENT_GROUPS: { group: string; events: WebhookEventWire[] }[] = (() => {
  const byGroup = new Map<string, WebhookEventWire[]>();
  const order: string[] = [];
  for (const event of ALL_WEBHOOK_EVENTS) {
    const group = groupFor(event);
    if (!byGroup.has(group)) {
      byGroup.set(group, []);
      order.push(group);
    }
    byGroup.get(group)!.push(event);
  }
  return order.map((group) => ({ group, events: byGroup.get(group)! }));
})();
